import { __assign } from "tslib";
import React, { useEffect, useRef } from 'react';
// @ts-ignore
import { __PRIVATE__ } from 'styled-components';
import MUIStylesProvider, { StylesContext as MUIStylesContext, } from '@material-ui/styles/StylesProvider';
import { StyleSheetManager } from '../../foundation';
import { buildJssFromWindow } from './utils';
export var RcDetachedWindowStylesProvider = function (props) {
    var externalWindow = props.externalWindow, jssInsertionPoint = props.jssInsertionPoint, children = props.children;
    var sheetsManagerRef = useRef(new Map());
    var jssCache = useRef();
    var sheetCache = useRef();
    useEffect(function () { return function () {
        jssCache.current = undefined;
        sheetCache.current = undefined;
    }; }, []);
    if (!jssCache.current) {
        jssCache.current = buildJssFromWindow(externalWindow, {
            insertionPoint: jssInsertionPoint,
        });
    }
    // We need to use the same styleSheet for the same window in case styled-component insert styles multiple times
    if (!sheetCache.current) {
        sheetCache.current = __PRIVATE__.masterSheet.reconstructWithOptions({ target: externalWindow.document.head }, false);
    }
    return (React.createElement(StyleSheetManager, { sheet: sheetCache.current },
        React.createElement(MUIStylesContext.Consumer, null, function (options) { return (React.createElement(MUIStylesProvider, __assign({}, options, { jss: jssCache.current, sheetsManager: sheetsManagerRef.current }), children)); })));
};
